import { CodeSpaceCombinedProps } from './types';

const usePresenter = (props: CodeSpaceCombinedProps): CodeSpaceCombinedProps => {

  const { updateHtmlFunction } = props;

  const onTextChanged = (_: unknown, event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (!updateHtmlFunction) {
      return;
    }
    updateHtmlFunction(event.target.value);
  };

  props = {
    ...props,
    hTMLTextArea: {
      ...props.hTMLTextArea,
      textArea: {
        textValue: props.hTMLTextArea?.textArea?.textValue,
        onTextChanged,
      },
    },
  };

  return props;
};

export default usePresenter;
